import { createSelector } from "@ngrx/store";
import * as fromLayout from '@app/core/reducers/layout.reducer';
import { getLayoutState } from ".";

export const getRegistrationSuccessText = createSelector(getLayoutState, fromLayout.getRegistrationSuccessText);
